import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import { mdiAbacus } from '@mdi/js';
import cookie from './plugins/cookie'

/*************デバッグモード************* */
Vue.config.devtools = true;

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  mdiAbacus,
  cookie,
  render: h => h(App)
}).$mount('#app')
